<template>
  <div class="pb-5">
    <nav-bar/>

    <table-element
      :isShowFilter="true"
      :title="$t('logs.title')"
      :fields="fieldsObj"
      :arrOfElement="logs"
      :sortSpacing="0"
      class="card mx-2 my-3"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(log, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td>{{getUserName(log.UID)}}</td>
          <td>{{$t('logs.action.' + log.action)}}{{log.status ? ': ' + log.status : ''}}{{log.targetName ? ': ' + log.targetName : ''}}</td>
          <td>{{getDate(log.date)}}</td>
          <td>{{log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName}}</td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(log, index) in content.results"
        class="card my-3 mx-2"
        :key="index">
          <div class="card-header m-2">
            <h4><strong>{{getUserName(log.UID)}}</strong></h4>
            <p>{{$t('logs.action.' + log.action)}}{{log.status ? ': ' + log.status : ''}}{{log.targetName ? ': ' + log.targetName : ''}}</p>
            <p>{{getDate(log.date)}}</p>
          </div>
          <div class="m-2">
            <p>{{log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName}}</p>
          </div>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />
  </div>
</template>

<script>
import regularInput from '../module/basic-components/regularInput.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import {dbLogs, db} from '../../firebase'

import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'

export default {
  name: 'Search',
  components: {
    regularInput,
    regularSelect,
    TableElement,
    LoadingRender
  },
  data () {
    return {
      filterResults: [],
      search: {},
      paginate: ['filterResults'],
      fields: {
        userName: '',
        action: '',
        date: '',
        target: ''
      },
      logs: [],
      users: [],
      fieldsObj: [
       {
         text: this.$t('logs.table_header.user'),
         type: 'user',
         value: ''
       },
       {
         text: this.$t('logs.table_header.action'),
         type: 'action',
         value: ''
       },
       {
         text: this.$t('logs.table_header.date'),
         type: 'date',
         value: ''
       },
       {
         text: this.$t('logs.table_header.target'),
         type: 'target',
         value: ''
       }
      ]
    }
  },

  async created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false

    if (this.isAdmin) {
      await this.$bindAsArray('logs', dbLogs.ref('logs/transporter/' + this.companyUID).limitToLast(2000))
      await this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID))
    }

    this.isLoading = false
  },

  methods: {
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },

    getUserName (uid) {
      if (uid === this.companyUID) return this.$t('logs.admin')
      let user = this.users.find((u) => {
        return u['.key'] === uid
      })
      return user ? user.firstName + ' ' + user.lastName : ''
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    reversedLogs () {
      return this.logs.slice().reverse()
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  }
}
</script>

<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
</style>
